jQuery(function ($) {
    const prevArrow = '<button type="button" class="slick-prev btn btn-link link-light" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/></svg></button>';
    const nextArrow = '<button type="button" class="slick-next btn btn-link link-light" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/></svg></button>';

    $('.header-nav .menu-item-has-children').on('mouseenter', function (e) {
        e.preventDefault();
        $(this).children('.sub-menu').stop().slideDown();
    }).on('mouseleave', function (e) {
        e.preventDefault();
        $(this).children('.sub-menu').stop().slideUp();
    });

    $('.mobile-nav .menu-item-has-children a').on('click', function (e) {
        $(this).parent().children('.sub-menu').stop().slideToggle();
    });

    $('.header-nav a').on('click', function (e) {
        if (this.getAttribute('href') === '#') {
            e.preventDefault();
            return false;
        }
    });

    $('.block-banner.banner-slides').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        cssEase: 'linear',
        prevArrow: prevArrow,
        nextArrow: nextArrow
    });
});